import { render, staticRenderFns } from "./Parte.vue?vue&type=template&id=0f93f3cf&"
import script from "./Parte.vue?vue&type=script&lang=js&"
export * from "./Parte.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports